import React from 'react';
import Carousel from 'react-bootstrap/Carousel';
import BusinessDeal from './img/businessdeal.svg';
import Analyse from './img/analyse.svg';
import SharedGoal from './img/sharedgoal.svg';
import Watchtower from './img/watchtower.svg';

//slides data
const slides = [
  {
    images: Watchtower,
    title: 'Welcome to the Watchtower',
    description:
      'An application that will help you optimize the work process and aid in efficient business decisions'
  },
  {
    images: SharedGoal,
    title: 'Find the oddity/anomaly in your data',
    description:
      'Our algorithms run over your business data and find the abnormalities to act at the right time',
    height: '60%'
  },
  {
    images: Analyse,
    title: 'Discover the rootcause & impact',
    description:
      'Watchtower helps you find the rootcause of the anomalies in your business data and act on the right path'
  },
  {
    images: BusinessDeal,
    title: 'Take action at the right time',
    description:
      'Time is the wisest counselor of all. Taking action at the right time will save your cost, effort and energy'
  }
];

//function to create carousel slide
function CarouselSlide(index, slide) {
  const height = slide.height ? slide.height : '65%';
  return (
    <Carousel.Item interval={3000} key={index}>
      <img
        className='d-block w-100'
        src={slide.images}
        style={{ padding: '2rem', height: height, marginTop: '2rem' }}
        alt='slide'
      />
      <Carousel.Caption>
        <h3>{slide.title}</h3>
        <p>{slide.description}</p>
      </Carousel.Caption>
    </Carousel.Item>
  );
}

//default export function
const CarouselPage = () => {
  return (
    <Carousel>
      {slides.map((slide, index) => CarouselSlide(index, slide))}
    </Carousel>
  );
};

export default CarouselPage;
